import { Layout, LayoutProps } from 'react-admin';
import AdminAppBar from './AdminAppBar';

const AdminLayout = (props: LayoutProps) => (
  <Layout {...props} appBar={AdminAppBar} />
);
export default AdminLayout;
